'use strict';

var _ = require('lodash');
var JQXTreeAdapterService = function JQXTreeAdapterService(GridColumnGroup, GridColumn, GroupNode, ColumnNode, SplitterNode, CustomColumnNode) {
  function getSplitterNode(gridId) {
    return new SplitterNode(gridId);
  }
  function shouldAddSplitterBetweenNodes(itemBefore, itemAfter) {
    return itemBefore && itemAfter && itemBefore.frozen !== itemAfter.frozen;
  }
  function isSplitterInCollection(nodes) {
    return _.some(nodes, function (node) {
      return node instanceof SplitterNode;
    });
  }
  function areAllNodesFrozen(nodes) {
    return _.every(nodes, 'frozen');
  }
  function addSplitterOnTop(nodes, gridId) {
    nodes.unshift(getSplitterNode(gridId));
  }
  function addSplitterOnBot(nodes, gridId) {
    nodes.push(getSplitterNode(gridId));
  }
  function createFormula(formula) {
    return {
      leftOperand: formula.leftOperand,
      operator: formula.operator,
      rightOperand: formula.rightOperand
    };
  }
  function isGridColumnGroupVisible(item) {
    return item.visible === false ? false : _.every(item.columns, {
      visible: true
    }) || !!item.dataDrivenColumn;
  }
  function convertGridDataToTreeNodes(columns, gridId) {
    return _.transform(columns, function (collection, item) {
      if (shouldAddSplitterBetweenNodes(_.last(collection), item)) {
        collection.push(getSplitterNode(gridId));
      }
      if (item instanceof GridColumn) {
        var props = {
          id: item.id,
          field: item.field,
          label: item.title,
          checked: item.visible,
          selected: false,
          frozen: item.frozen,
          custom: item.custom,
          formula: item.formula ? createFormula(item.formula) : undefined,
          groupId: item.groupId,
          groupLabel: item.groupTitle,
          originalLabel: item.originalTitle,
          gridId: gridId
        };
        if (item.custom) {
          collection.push(new CustomColumnNode(props));
        } else {
          collection.push(new ColumnNode(props));
        }
      } else if (item instanceof GridColumnGroup) {
        var items = item.dataDrivenColumn ? [] : convertGridDataToTreeNodes(item.columns);
        var isGroupVisible = isGridColumnGroupVisible(item);
        if (!item.dynamicConfigDrivenColumn) {
          collection.push(new GroupNode({
            id: item.id,
            label: item.title,
            checked: isGroupVisible,
            selected: true,
            items: items,
            expanded: false,
            frozen: item.frozen,
            custom: item.custom,
            dataDrivenColumn: item.dataDrivenColumn
          }));
        }
      }
    });
  }
  function getDataAdapter(settings) {
    var nodes = convertGridDataToTreeNodes(settings.columns, settings.gridId);
    //add to bottom: check frozen status. If all frozen, then add splitter on bottom.
    if (!isSplitterInCollection(nodes) && !areAllNodesFrozen(nodes)) {
      addSplitterOnTop(nodes, settings.gridId);
    } else if (areAllNodesFrozen(nodes)) {
      addSplitterOnBot(nodes, settings.gridId);
    }
    return nodes;
  }
  return {
    getDataAdapter: getDataAdapter
  };
};
JQXTreeAdapterService.$inject = ['GridColumnGroupFactory', 'GridColumnFactory', 'JQXTreeNodeGroupFactory', 'JQXTreeNodeColumnFactory', 'JQXTreeNodeSplitterFactory', 'JQXTreeNodeCustomColumnFactory'];
module.exports = JQXTreeAdapterService;